import { Skeleton, useMediaQuery } from "@mui/material";
import { TitleContainer } from "./styles";

export const CompaniesSkeleton = () => {
  const isTablet = useMediaQuery("(max-width:768px)");
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <>
      <TitleContainer
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          gap: "14px",
          alignItems: "center",
        }}
      >
        <Skeleton
          variant="rectangular"
          width={isMobile ? "320px" : "500px"}
          height={isMobile ? "24px" : "32px"}
          style={{ borderRadius: "20px" }}
        />

        <div
          style={{
            display: "flex",
            gap: isTablet ? "16px" : "40px",
            alignItems: "center",
          }}
        >
          {Array.from({ length: isMobile ? 5 : isTablet ? 6 : 7 }).map(
            (_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                width={isMobile ? "48px" : "96px"}
                height={isMobile ? "20px" : "36px"}
                style={{ borderRadius: "20px" }}
              />
            )
          )}
        </div>
      </TitleContainer>
    </>
  );
};
